// 商户列表模拟数据
export const productList = [
  {
    id: 1,
    productNo: 'M24031510301234567890123',
    productName: '商户A',
    productId: '商户A',
    walletAddress: '钱包地址A',
    balance: 0.00,
    flow: 0.00,
    agentBalance: 0.00,
    agentFlow: 0.00,
    authIp: '',
    loginCount: 0,
    verified: 'N',
    enableDeposit: true,
    registerTime: '2024-03-15 10:30:15'
  },
  {
    id: 2,
    productNo: 'M24032014251234567890124',
    productName: '商户B',
    productId: '商户B',
    walletAddress: '钱包地址B',
    balance: 739862.00,
    flow: 0.00,
    agentBalance: 0.00,
    agentFlow: 0.00,
    subAccounts: [5, 6, 7],
    authIp: '',
    loginCount: 0,
    verified: 'N',
    enableDeposit: false,
    registerTime: '2024-03-20 14:25:36'
  },
  {
    id: 3,
    productNo: 'M24021008151234567890125',
    productName: '商户C',
    productId: '商户C',
    walletAddress: '钱包地址C',
    balance: 56280.50,
    flow: 12450.75,
    agentBalance: 1250.00,
    agentFlow: 320.50,
    authIp: '192.168.1.100',
    loginCount: 5,
    verified: 'Y',
    enableDeposit: true,
    registerTime: '2024-02-10 08:15:42'
  },
  {
    id: 4,
    productNo: 'M24021509201234567890126',
    productName: '商户D',
    productId: '商户D',
    walletAddress: '钱包地址D',
    balance: 123570.25,
    flow: 32680.90,
    agentBalance: 3460.30,
    agentFlow: 750.80,
    authIp: '192.168.1.101',
    loginCount: 8,
    verified: 'Y',
    enableDeposit: false,
    registerTime: '2024-02-15 09:20:30'
  },
  {
    id: 5,
    productNo: 'M24022011451234567890127',
    productName: '商户E',
    productId: '商户E',
    walletAddress: '钱包地址E',
    balance: 298640.70,
    flow: 56790.40,
    agentBalance: 5830.20,
    agentFlow: 1240.60,
    authIp: '192.168.1.102',
    loginCount: 3,
    verified: 'Y',
    enableDeposit: true,
    registerTime: '2024-02-20 11:45:18'
  },
  {
    id: 6,
    productNo: 'M24022514301234567890128',
    productName: '商户F',
    productId: '商户F',
    walletAddress: '钱包地址F',
    balance: 78950.30,
    flow: 24680.10,
    agentBalance: 2340.50,
    agentFlow: 580.30,
    authIp: '192.168.1.103',
    loginCount: 6,
    verified: 'Y',
    enableDeposit: false,
    registerTime: '2024-02-25 14:30:55'
  },
  {
    id: 7,
    productNo: 'M24030116101234567890129',
    productName: '商户G',
    productId: '商户G',
    walletAddress: '钱包地址G',
    balance: 186420.80,
    flow: 42380.60,
    agentBalance: 4120.40,
    agentFlow: 920.70,
    authIp: '192.168.1.104',
    loginCount: 4,
    verified: 'N',
    enableDeposit: true,
    registerTime: '2024-03-01 16:10:25'
  },
  {
    id: 8,
    productNo: 'M24030510051234567890130',
    productName: '商户H',
    productId: '商户H',
    walletAddress: '钱包地址H',
    balance: 92360.45,
    flow: 18750.30,
    agentBalance: 1890.60,
    agentFlow: 420.80,
    authIp: '192.168.1.105',
    loginCount: 7,
    verified: 'Y',
    enableDeposit: false,
    registerTime: '2024-03-05 10:05:40'
  },
  {
    id: 9,
    productNo: 'M24031012401234567890131',
    productName: '商户I',
    productId: '商户I',
    walletAddress: '钱包地址I',
    balance: 314790.60,
    flow: 68450.20,
    agentBalance: 6230.80,
    agentFlow: 1380.40,
    authIp: '192.168.1.106',
    loginCount: 9,
    verified: 'Y',
    enableDeposit: true,
    registerTime: '2024-03-10 12:40:15'
  },
  {
    id: 10,
    productNo: 'M24031515251234567890132',
    productName: '商户J',
    productId: '商户J',
    walletAddress: '钱包地址J',
    balance: 468520.35,
    flow: 87620.90,
    agentBalance: 8450.70,
    agentFlow: 1860.50,
    authIp: '192.168.1.107',
    loginCount: 2,
    verified: 'N',
    enableDeposit: false,
    registerTime: '2024-03-15 15:25:30'
  }
];